/**
 * Webapp Routes
 *
 * Domain-prefixed routing structure for the webapp.
 * All routes use the pattern /:organisation/{domain}/{entity}
 */

import accounting from './accounting/index.js';
import ai from './ai/index.js';
import banking from './banking/index.js';
import crm from './crm/index.js';
import finance from './finance/index.js';
import home from './home/index.js';
import hr from './hr/index.js';
import inventory from './inventory/index.js';
import investment from './investment/index.js';
import loans from './loans/index.js';
import payables from './payables/index.js';
import portals from './portals/index.js';
import practiceManagement from './practice-management/index.js';
import profile from './profile/index.js';
import projects from './projects/index.js';
import receivables from './receivables/index.js';
import reports from './reports/index.js';
import settings from './settings/index.js';
import shared from './shared/index.js';
import system from './system/index.js';
import taxCompliance from './tax-compliance/index.js';

export default [
    ...shared,
    ...home,
    ...profile,
    ...settings,
    ...portals,
    ...ai,
    ...banking,
    ...accounting,
    ...crm,
    ...inventory,
    ...receivables,
    ...payables,
    ...hr,
    ...finance,
    ...investment,
    ...loans,
    ...taxCompliance,
    ...practiceManagement,
    ...projects,
    ...reports,
    ...system,
];
